import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

import { Modal } from 'components/Modal';

export const StyledModal = styled(Modal)`
  overflow: visible;
`;

export const StyledModalFooter = styled.div`
  ${setFontVariant('sectionTitle', colorsPalettes.carbon[400])};
  flex: 1;
  span {
    font-weight: 700;
  }
`;

export const StyledPreviewLoader = styled.div`
  width: 100%;
  min-height: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 12px;
`;

export const StyledDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${colorsPalettes.carbon[100]};
`;

export const StyledBulkText = styled.div`
  ${setFontVariant('body1', colorsPalettes.carbon[400])};
  padding: 8px 16px;
  margin-bottom: 4px;
`;

export const StyledContactList = styled.div<{ enableScroll?: boolean; isCrmLabelsEnabled: boolean }>`
  max-height: ${({ isCrmLabelsEnabled }) => `calc(100vh - ${isCrmLabelsEnabled ? 296 : 326}px)`};
  overflow-y: ${({ enableScroll }) => (enableScroll ? 'auto' : 'visible')};
  border-bottom: 1px solid ${colorsPalettes.carbon[100]};
`;

export const StyledContactListHeaderRow = styled.div`
  display: flex;
  gap: 4px;
  width: 100%;
  padding: 0 16px 8px;
  margin-top: 12px;
  align-items: center;
  border-bottom: 1px solid ${colorsPalettes.carbon[100]};
  ${setFontVariant('sectionTitle', colorsPalettes.carbon[400])};
`;

export const StyledContactListRow = styled(StyledContactListHeaderRow)<{ isDisabled?: boolean }>`
  padding: 0 16px;
  margin: 0;
  min-height: 72px;
  background-color: ${({ isDisabled }) => (isDisabled ? colorsPalettes.carbon[25] : colorsPalettes.carbon[0])};

  &:last-child {
    border-bottom: none;
  }
`;

export const StyledContactListColumn = styled.div`
  width: 50%;
  ${setFontVariant('sectionTitle', colorsPalettes.carbon[500])};
`;

export const StyledContactListText = styled.div`
  ${setFontVariant('sectionTitle', colorsPalettes.carbon[300])};
`;

export const StyledContactListName = styled.div`
  display: flex;
  gap: 4px;
  margin-bottom: 4px;
  ${setFontVariant('report', colorsPalettes.carbon[400])};
`;
